import React, { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

function LandingPageHeader() {
    const pageHeader = useRef(null);
    const titleRef = useRef(null);

    const [underlineWidth, setUnderlineWidth] = useState(0);
    const [headerData, setHeaderData] = useState({
        title: "YAYASAN KARYA BAKTI UNITED TRACTORS",
        image_url: null,
    });

    // === Fetch header image dari API ===
    useEffect(() => {
        const fetchHeader = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/header/home`);
                console.log(res);
                if (res.data) {
                    setHeaderData({
                        title: res.data.title || "YAYASAN KARYA BAKTI UNITED TRACTORS",
                        image_url: res.data.image_url || null,
                    });
                }
                console.log(res.data);
            } catch (error) {
                console.error("Error fetching header image:", error);
            }
        };
        fetchHeader();
    }, []);

    // === AOS + efek scroll parallax ===
    useEffect(() => {
        AOS.init({ duration: 1000 });
        if (titleRef.current) {
            setUnderlineWidth(titleRef.current.offsetWidth);
        }

        if (window.innerWidth > 991) {
            const updateScroll = () => {
                let windowScrollTop = window.pageYOffset / 3;
                if (pageHeader.current) {
                    pageHeader.current.style.transform = `translate3d(0, ${windowScrollTop}px, 0)`;
                }
            };
            window.addEventListener("scroll", updateScroll);
            return () => window.removeEventListener("scroll", updateScroll);
        }
    }, []);

    return (
        <>
            <div className="page-header page-header-small">
                <div
                    className="page-header-image"
                    ref={pageHeader}
                    style={{
                        backgroundImage: headerData.image_url
                            ? `url(${encodeURI(headerData.image_url)}?v=${Date.now()})`
                            : `url("/assets/img/hero.png")`,
                        backgroundSize: "cover",
                        backgroundPosition: headerData.focus_position || "center",
                        backgroundRepeat: "no-repeat",
                        minHeight: "60vh",
                    }}
                ></div>

                <div className="content-center">
                    <Container>
                        <h2 className="title" data-aos="fade-left" ref={titleRef}>
                            {headerData.title}
                        </h2>
                        <div
                            className="underline"
                            data-aos="fade-right"
                            data-aos-delay="300"
                            style={{ width: underlineWidth }}
                        ></div>
                    </Container>
                </div>
            </div>

            <style jsx>{`
                .underline {
                    height: 4px;
                    background-color: white;
                    margin: 10px auto;
                    transition: all 1.5s ease;
                }
            `}</style>
        </>
    );
}

export default LandingPageHeader;
